module.exports = __webpack_public_path__ + "static/media/mateo_pellegrino.02cd81c5.jpg";